import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollRestoration — mounts once inside BrowserRouter.
 *
 * • Non-hash routes  → instant scroll to (0, 0) so every page starts at the top.
 * • Hash routes      → hash scrolling is delegated to react-router-hash-link
 *                      (which already calls scrollWithOffset on each HashLink).
 *                      This component deliberately does nothing so the two
 *                      mechanisms never fight each other.
 * • window.history.scrollRestoration = "manual" prevents the browser from trying to
 *   restore its own scroll position on back/forward, which would conflict.
 */
const ScrollRestoration = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollRestoration;
